import $ from 'jquery';

(() => {

  // Collapse focus behavior

  // Selector for getting tab-focusable elements
  const focusableSelector = 'a[href], area[href], input:not([disabled]):not([tabindex=\'-1\']), ' +
    'button:not([disabled]):not([tabindex=\'-1\']),select:not([disabled]):not([tabindex=\'-1\']), textarea:not([disabled]):not([tabindex=\'-1\']), ' +
    'iframe, object, embed, *[tabindex]:not([tabindex=\'-1\']), *[contenteditable=true]';

  $(function() {
    // When collapse toggle element with [data-collapse-toggle-focus-trap="#target"] is focused, trap tab focus within the collapse toggle and in the collapse target element
    // Pressing escape when the collapse is expanded will activate the collapse toggle
    $('[data-collapse-toggle-focus-trap="true"]').each(function() {
      let $toggleElement = $(this);
      let $trapElement = $($toggleElement.data('target'));
      let $focusableTrapElements = $trapElement.find(focusableSelector);

      $toggleElement.keydown(function(event) { setToggleEscape(event, $toggleElement) } );
      $focusableTrapElements.keydown(function(event) { setToggleEscape(event, $toggleElement) } );
      $toggleElement.keydown(function(event) { setFocusNext(event, $focusableTrapElements.first()) });
      $focusableTrapElements.first().keydown(function(event) { setFocusPrevious(event, $toggleElement) });
      $focusableTrapElements.last().keydown(function(event) { setFocusNext(event, $toggleElement) });
    });

    // When collapse element with [data-collapse-focus-first-on-show="true"] is shown, focus on its first focusable element
    $('[data-collapse-focus-first-on-show="true"]').on('shown.bs.collapse', function() {
      let $focusableTrapElements = $(this).find(focusableSelector);
      $focusableTrapElements.first().focus();
    });
  });

  // When collapse is expanded and Escape key is pressed, focus on the toggle element and close the collapse
  function setToggleEscape(event, $toggleElement) {
    if (event.key == 'Escape' && $toggleElement.is('[aria-expanded="true"]')) {
      $toggleElement.focus();
      $toggleElement.click();
      event.preventDefault();
    }
  }

  // Set focus to the specified element on Shift + Tab key
  function setFocusPrevious(event, $focusElement) {
    if (event.shiftKey && event.key === 'Tab') {
      if ($focusElement.is(':visible')) {
        $focusElement.focus();
        event.preventDefault();
      }
    }
  }

  // Set focus to the specified element on Tab key
  function setFocusNext(event, $focusElement) {
    if (!event.shiftKey && event.key === 'Tab') {
      if ($focusElement.is(':visible')) {
        $focusElement.focus();
        event.preventDefault();
      }
    }
  }
})();